import { Flex, Box } from '@cad-arc';
import React from 'react';
import {
    SkeletonText,
    Skeleton,
    SkeletonTitle,
    SkeletonButton,
} from '../../../../../common/components/skeletons';

export const ManageEventMergeModalBodySkeleton: React.FC = () => {
    return (
        <Flex w="100%" direction="column">
            <SkeletonText />
            <Skeleton />
            <Box mt="8px">
                <SkeletonText />
                <Skeleton />
                <Skeleton />
                <Skeleton />
            </Box>
        </Flex>
    );
};

export const ManageEventMergeManagerHeaderSkeleton: React.FC = () => (
    <Flex direction="column">
        <SkeletonTitle />
        <SkeletonText width="35%" />
        <SkeletonText width="30%" />
    </Flex>
);

export const ManageEventMergeManagerFooterSkeleton: React.FC = () => (
    <Flex justify="end">
        <SkeletonButton />
        <SkeletonButton />
    </Flex>
);
